import { useState } from "react";
import Text from "./Text";
import { produce } from "immer";
import { useEffect } from "react";
import Select from "./Select";

const Address = ({ isRequired, label, thanaList, districtList, value, onChange = () => {} }) => {
  const [state, setState] = useState(null);
  const [thana, setThana] = useState(null);
  // const [thanaList, setAllThana] = useState(thanaList);
  // const [districtList, setDistrict] = useState(districtList);

  const { village, district_id = 44, postOffice } = state || {};

  useEffect(() => {
    if (district_id && thanaList) {
      setThana(thanaList?.filter((item) => item.district_id == district_id));
    }
  }, [district_id, thanaList]);

  const handleChange = (key, value) => {
    const newState = produce(state || {}, (draft) => {
      if (key === "district") {
        const item = districtList?.find((item) => item.id === value);
        draft[key] = item?.name;
        draft["district_id"] = item?.id;
        draft.thana = null;
      } else {
        draft[key] = value;
      }
    });
    setState(newState);
  };

  useEffect(() => {
    onChange(state);
  }, [state]);

  useEffect(() => {
    if (value) {
      setState(Array.isArray(value) ? {} : value);
    }
  }, []);

  if (!thanaList?.length || !districtList?.length) {
    return <></>;
  }

  return (
    <>
      <label className="mmmbaa_label">
        {label}
        {isRequired ? <span className="required_star">*</span> : ""}
      </label>
      <div className="mmmbaa_address">
        <div className="form_field half_width">
          <Text value={village} placeholder={"Village"} onChange={(village) => handleChange("village", village)} />
        </div>
        <div className="form_field half_width">
          <Text value={postOffice} placeholder={"Post Office"} onChange={(postOffice) => handleChange("postOffice", postOffice)} />
        </div>
        <div className="form_field half_width">
          {/* <label className="mmmbaa_label">
        {label}
      </label> */}
          <Select
            value={state?.district}
            options={Array.isArray(districtList) ? districtList.map((item) => ({ label: item.name, value: item.id })) : []}
            onChange={(district) => {
              handleChange("district", district);
              // setSelectedDistrict(district);
            }}
            placeholder="Select District"
          />
        </div>
        <div className="form_field half_width">
          <Select
            placeholder="Select Upazila/P.S."
            value={state?.thana}
            options={Array.isArray(thana) ? thana.map((item) => item.name) : []}
            onChange={(thana) => handleChange("thana", thana)}
          />
        </div>
      </div>
    </>
  );
};

export default Address;

export function sortJsonArrayAlphabetically(jsonArray) {
  return jsonArray.sort((a, b) => {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    return 0;
  });
}

// // Example usage:
// const unsortedJsonArray = [
//   { id: '1', name: 'Dhaka', ... },
//   { id: '2', name: 'Faridpur', ... },
//   { id: '3', name: 'Gazipur', ... },
//   // Add more objects here
// ];

// const sortedJsonArray = sortJsonArrayAlphabetically(unsortedJsonArray);
// console.log(sortedJsonArray);
